import videojs from 'video.js';

export const DEFAULT_OPTIONS = {
  controlInteractions: true,
  controlBar: {
    children: [
      'placeholderTitleDescription',
      'choicesBar',
      'playToggle',
      'durationDisplay',
      'timeDivider',
      'currentTimeDisplay',
      'progressControl',
      'volumePanel',
    ],
  },
  autoSetup: false,
  preload: 'auto',
  autoplay: false,
  loadingSpinner: true,
  // We're taking charge of the reveal of the controls
  // so we're disabling the player tracking the inactivity
  // https://github.com/videojs/video.js/blob/b86f083a8877073a4d4d0a2fda4ce0e632912112/docs/guides/options.md#inactivitytimeout
  inactivityTimeout: 0,
  // Disable double click to fullscreen until a solution is found
  // to emulate fullscreen with the choices on iOS
  userActions: {
    click: false,
    doubleClick: false,
  },
  crossOrigin: 'anonymous',
  html5: {
    nativeControlsForTouch: false,
    nativeAudioTracks: false,
    nativeVideoTracks: false,
    vhs: {
      bandwidth: 70594304,
      experimentalBufferBasedABR: true,
      // Overriding native causes flicker on Safari.
      // Later version of VideoJS will default to IS_ANY_SAFARI
      // so we can remove at some point in the future
      // https://github.com/videojs/http-streaming/issues/505
      overrideNative: !(
        videojs.browser.IS_IPAD ||
        videojs.browser.IS_IPHONE ||
        videojs.browser.IS_IPOD
      ),
    },
  },
  errorDisplay: process.env.NODE_ENV == 'development',
};

export const VR_OPTIONS = {
  projection: 'AUTO',
  disableTogglePlay: true,
};
